/**
 * Formats a number as a price with comma separators
 * @param price The number to format
 * @returns A string representation of the price with comma separators
 */
export function formatPrice(price: number): string {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
